import { ProfileDetailsCardProps } from "./types";
import { useAuth } from "context/AuthProvider";
import { useHistory } from "react-router-dom";
import MyBusinessProfile from "./MyBusinessProfile";
import React, { useState } from "react";
import useQueryInstructorBusinessProfile from "./hooks/useQueryInstructorBusinessProfile";

const StateProvider = () => {
  const history = useHistory();
  const { instructor } = useAuth();
  const [
    profileDetails,
    setProfileDetails,
  ] = useState<ProfileDetailsCardProps | null>(null);

  const onQueryCompleted = (data: any) => {
    if (!data) {
      setProfileDetails({
        loading: false,
        handleAddDetailsOnClick: () => {
          history.push(`/my-business-profile/profile-details`);
        },
      });
      return;
    }
    const profileDetailsData: ProfileDetailsCardProps = {
      handleAddDetailsOnClick: () =>
        history.push(`/my-business-profile/profile-details`, {
          data: {
            displayName: data.getInstructorBusinessProfile.displayName,
            additionalLanguages:
              data.getInstructorBusinessProfile.additionalLanguages,
            bio: data.getInstructorBusinessProfile.bio,
            badgeDate: data.getInstructorBusinessProfile.badgeDate,
            questionAnswers: data.getInstructorBusinessProfile.questionAnswers,
            badgeType: data.getInstructorBusinessProfile.badgeType,
          },
        }),
      displayName: data.getInstructorBusinessProfile.displayName,
      additionalLanguages:
        data.getInstructorBusinessProfile.additionalLanguages,
      bio: data.getInstructorBusinessProfile.bio,
      profileUrls: data.getInstructorBusinessProfile.profileUrls,
      awards: data.getInstructorBusinessProfile.awards,
    };
    setProfileDetails(profileDetailsData);
  };

  const { loading } = useQueryInstructorBusinessProfile({
    onCompleted: onQueryCompleted,
    fetchPolicy: "network-only",
    variables: {
      personKey: instructor.id,
    },
  });

  return <MyBusinessProfile profileDetails={{ ...profileDetails, loading }} />;
};

export default StateProvider;
